import React from "react";
import { FormattedMessage } from "react-intl";

const TranslatedKey = ({ id }) => {
  return <FormattedMessage id={id} defaultMessage={id} />;
};

export default TranslatedKey;
